import axios from "api/axios";
import {
  IMasterAchievementResponse,
  IMasterJudgingMasterResponse,
  IMasterOccupationRelateElbResponse,
  IMasterOccupationRelateParResponse,
  IMaster,
  IMasterTagResponse,
  IMasterThemeResponse,
  IMasterTag,
  ISupportedChain,
  IInfrastructureDeployeds,
} from "./types";

export const masterAchievementRequest = async (): Promise<
  IMasterAchievementResponse[]
> => {
  const { data } = await axios({
    url: "/master/achievements",
    method: "GET",
  });
  return data;
};

export const masterAddActionRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/addActions",
    method: "GET",
  });
  return data;
};

export const masterComunityRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/community",
    method: "GET",
  });
  return data;
};

export const masterCompanyRequireRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/companyRequire",
    method: "GET",
  });
  return data;
};

export const masterGeoRestrictionsRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/geoRestrictions",
    method: "GET",
  });
  return data;
};

export const masterJudgingRequest = async (): Promise<
  IMasterJudgingMasterResponse[]
> => {
  const { data } = await axios({
    url: "/master/judging",
    method: "GET",
  });
  return data;
};

export const masterLengthRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/length",
    method: "GET",
  });
  return data;
};

export const masterLocationRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/location",
    method: "GET",
  });
  return data;
};

export const masterOccupationElbRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/occupationElb",
    method: "GET",
  });
  return data;
};

export const masterOccupationParRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/occupationPar",
    method: "GET",
  });
  return data;
};

export const masterOccupationRelateElbRequest =
  async (): Promise<IMasterOccupationRelateElbResponse> => {
    const { data } = await axios({
      url: "/master/occupationRelateElb",
      method: "GET",
    });
    return data;
  };

export const masterOccupationRelateParRequest =
  async (): Promise<IMasterOccupationRelateParResponse> => {
    const { data } = await axios({
      url: "/master/occupationRelatePar",
      method: "GET",
    });
    return data;
  };

export const masterOrganizationRequest = async (): Promise<IMaster[]> => {
  const { data } = await axios({
    url: "/organization/find_all",
    method: "GET",
  });
  return data;
};

export const masterParticipantAgeRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/participantAge",
    method: "GET",
  });
  return data;
};

export const masterPrizeCurrencyRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/prizeCurrency",
    method: "GET",
  });
  return data;
};

export const masterSpecialtyRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/specialty",
    method: "GET",
  });
  return data;
};

export const masterStatusRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/status",
    method: "GET",
  });
  return data;
};

export const masterTagRequest = async (): Promise<IMasterTagResponse[]> => {
  const { data } = await axios({
    url: "/master/tags",
    method: "GET",
  });
  return data;
};

export const masterTeamRequireRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/master/teamRequire",
    method: "GET",
  });
  return data;
};

export const masterThemeRequest = async (): Promise<IMasterThemeResponse[]> => {
  const { data } = await axios({
    url: "/theme/find_all",
    method: "GET",
  });
  return data;
};

export const getPopularTagRequest = async (): Promise<
  IMasterThemeResponse[]
> => {
  const { data } = await axios({
    url: "/theme/popular-theme-tag",
    method: "GET",
  });
  return data;
};

export const masterTypeRequest = async (): Promise<string[]> => {
  const { data } = await axios({
    url: "/theme/find_all",
    method: "GET",
  });
  return data;
};

export const masterTechnologyRequest = async (): Promise<IMaster[]> => {
  const { data } = await axios({
    url: "/tags/find_all",
    method: "GET",
  });
  return data;
};

export const masterCategoryRequest = async (): Promise<IMaster[]> => {
  const { data } = await axios({
    url: "/categories/find_all",
    method: "GET",
  });
  return data;
};
export const createNewOrganizationRequest = async (params: {
  name: string;
}): Promise<IMaster[]> => {
  const { data } = await axios({
    url: "/organization/create_request",
    method: "POST",
    data: params,
  });
  return data;
};

export const masterChildTagRequest = async (): Promise<IMasterTag> => {
  const { data } = await axios({
    url: "/parent-tag/find_all",
    method: "GET",
  });
  return data;
};
export const getSupportedChainRequest = async (): Promise<
  ISupportedChain[]
> => {
  const { data } = await axios({
    url: "/supported-chains/find-all",
    method: "GET",
  });
  return data;
};

export const getInfrastructureDeployedsRequest = async (): Promise<
  IInfrastructureDeployeds[]
> => {
  const { data } = await axios({
    url: "/infrastructure-deployeds/find-all",
    method: "GET",
  });
  return data;
};
